import { render, staticRenderFns } from "./WorkIconSerialNumber.vue?vue&type=template&id=28ced43c"
import script from "./WorkIconSerialNumber.vue?vue&type=script&lang=js"
export * from "./WorkIconSerialNumber.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports